import type { NonEmptyArray } from '@crossbeam/types';

type ApiIntegrationFixtureType = {
  id: string;
  name: string;
  clientId: string;
  created: string;
  lastUsed: string;
  callbackUrl: string;
};

export const API_INTEGRATION_FIXTURES: NonEmptyArray<ApiIntegrationFixtureType> =
  [
    {
      id: 'int_snowflake_sync',
      name: 'Snowflake sync',
      clientId: 'cb_int_a91f_c220',
      created: 'May 13, 2026',
      lastUsed: '3 hours ago',
      callbackUrl: 'https://oauth.pstmn.io/v1/callback',
    },
    {
      id: 'int_partner_bi_reporting',
      name: 'Partner BI reporting',
      clientId: 'cb_int_77b3_9e01',
      created: 'Nov 18, 2025',
      lastUsed: '1 day ago',
      callbackUrl: 'https://localhost:3001/authorize/callback',
    },
  ];
